import $ from "jquery";
import { GuiDetailMandant } from "./GuiDetailMandant";

export class GuiDetailSupportMandant extends GuiDetailMandant {

    // Prellschutz: Löschen nur einmal absenden
    private deleteMandantInProgress = false;
    private checkEanvInProgress = false;

    constructor() {
        super();

        $("#frmDeleteMandant").on("submit", (e: JQuery.SubmitEvent) => this.submitDeleteMandant(e));
        $("#mdlDeleteMandant").on("shown.bs.modal", () => $("#mdlDeleteMandantZweiterFaktor").trigger("focus"));
        $("#btnLoadEanvProvider").on("click", (e: JQuery.ClickEvent<HTMLElement, undefined, HTMLElement, HTMLElement>) => this.clickLoadEanvProvider(e));
        $("#frmCheckEanv").on("submit", (e: JQuery.SubmitEvent) => this.submitCheckEanv(e));
    }

    // Mandant löschen: eigener Dialog mit 2FA-Abfrage statt des generischen Bestätigungsdialogs (DEVCLR-351).
    // Nicht berechtigte Benutzer (reine SSO / ohne 2FA) sehen den Löschen-Button gar nicht.
    protected override clickBarDelete(e: JQuery.ClickEvent<HTMLElement, undefined, HTMLElement, HTMLElement>) {
        this.log("clickBarDelete");
        e.preventDefault();

        this.deleteMandantInProgress = false;
        $("#mdlDeleteMandantZweiterFaktor").val("");
        $("#mdlDeleteMandantBtnDelete").prop("disabled", false).find(".spinner-grow").remove();
        $("#mdlDeleteMandant").modal("show");
    }

    private submitDeleteMandant(e: JQuery.SubmitEvent) {
        this.log("submitDeleteMandant");

        if (this.deleteMandantInProgress) {
            e.preventDefault();
            return;
        }
        this.deleteMandantInProgress = true;

        const btn = $("#mdlDeleteMandantBtnDelete");
        btn.prop("disabled", true);
        this.createSpinner(btn);
    }

    // Zedal-Provider per Ajax laden und Dropdown füllen, bisherige Auswahl bleibt erhalten (DEVCLR-360).
    private clickLoadEanvProvider(e: JQuery.ClickEvent<HTMLElement, undefined, HTMLElement, HTMLElement>) {
        this.log("clickLoadEanvProvider");
        e.preventDefault();

        const btn = $(e.currentTarget);
        const select = $("#VmDetail_EanvProvider");
        const url = select.data("url") as string;
        const selected = (select.val() as string) ?? "";

        btn.prop("disabled", true);
        this.createSpinner(btn);

        $.ajax({
            type: "GET",
            url: url,
            cache: false
        }).done((data: EanvProviderListResponse) => {
            if (!data.erfolg) {
                this.createToastValidate("Eanv-Provider", this.escapeHtml(data.meldung ?? "Fehler"), "danger", 20000);
                return;
            }

            const defaultText = data.providerDefault ? `(Standard: ${data.providerDefault})` : "(Standard aus zedal.json)";
            select.empty();
            select.append($("<option>").val("").text(defaultText));
            data.providerList.forEach((name) => select.append($("<option>").val(name).text(name)));

            // gespeicherter Provider, den Zedal nicht (mehr) kennt, bleibt sichtbar statt still verworfen zu werden
            if (selected !== "" && data.providerList.indexOf(selected) < 0) {
                select.append($("<option>").val(selected).text(`${selected} (nicht bei Zedal gefunden)`));
            }
            select.val(selected);

            this.createToastValidate("Eanv-Provider", `${data.providerList.length} Provider geladen.`, "info", 5000);
        }).fail(() => {
            this.createToastValidate("Eanv-Provider", "Provider konnten nicht geladen werden.", "danger", 20000);
        }).always(() => {
            btn.prop("disabled", false).find(".spinner-grow").remove();
        });
    }

    // Postfächer des betrachteten Mandanten prüfen (POST frmCheckEanv); Ergebnis kommt als Toasts nach dem Reload.
    // Geprüft wird mit dem GESPEICHERTEN Provider, eine ungespeicherte Auswahl im Dropdown zählt nicht.
    private submitCheckEanv(e: JQuery.SubmitEvent) {
        this.log("submitCheckEanv");

        // Prellschutz: nur einmal absenden
        if (this.checkEanvInProgress) {
            e.preventDefault();
            return;
        }
        this.checkEanvInProgress = true;

        const btn = $("#btnCheckEanvSupport");
        btn.prop("disabled", true);
        this.createSpinner(btn);
    }

    private escapeHtml(value: string): string {
        return $("<div>").text(value).html();
    }
}

interface EanvProviderListResponse {
    erfolg: boolean;
    meldung: string | null;
    providerList: string[];
    providerDefault: string | null;
}
